/**
 * Main App Component
 */

import { Alert, CssBaseline, Snackbar, ThemeProvider } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { ApiProgressBar } from './components/common/ApiProgressBar';
import { RootErrorBoundary } from './components/common/ErrorBoundary';
import { AppRoutes } from './routes/AppRoutes';
import { ApiErrorDetail, apiErrorBus } from './services/apiProgress';
import './styles/globals.scss';
import { theme } from './theme';

const GlobalApiErrorSnackbar: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handler = (e: Event) => {
      const { message } = (e as CustomEvent<ApiErrorDetail>).detail;
      setMessage(message);
      setOpen(true);
    };
    apiErrorBus.addEventListener('api-error', handler);
    return () => apiErrorBus.removeEventListener('api-error', handler);
  }, []);

  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert severity="error" onClose={() => setOpen(false)} sx={{ width: '100%' }} data-testid="error-message">
        {message}
      </Alert>
    </Snackbar>
  );
};

const App: React.FC = () => {
  return (
    <RootErrorBoundary>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ApiProgressBar />
        <GlobalApiErrorSnackbar />
        <AppRoutes />
      </ThemeProvider>
    </RootErrorBoundary>
  );
};

export default App;
